// Client-side mirror of the server-authoritative MatchState (Phase 0, Task 7).
//
// Holds `{ state, version }` and folds inbound Full/Diff messages with the same
// vendored reducer the server uses (`foldInbound` from `matchCore.js`). On a
// version gap it leaves state untouched and invokes the injected `requestFull`
// callback so the caller can ask the server for a fresh Full.
import { foldInbound } from './matchCore.js';

export class ClientMirror {
  constructor({ requestFull } = {}) {
    this.requestFull = requestFull;
    this.state = null;
    this.version = -1;
  }

  applyInbound(msg) {
    const result = foldInbound(this.version, this.state, msg);
    if (result.needFull) {
      if (this.requestFull) this.requestFull();
      return;
    }
    this.state = result.state;
    this.version = result.version;
  }

  getState() {
    return this.state;
  }
}
